import * as React from 'react';

import { Button, Modal, Grid } from 'antd';

import type { AddressKitInfo } from 'v2/interfaces/addressKit';

const { useBreakpoint } = Grid;

type ConfirmAddressProps = {
  isOpen: boolean;
  setIsOpen: (prev: boolean) => void;
  data: AddressKitInfo;
};

const ConfirmAddress = ({ isOpen, setIsOpen, data: { name } }: ConfirmAddressProps) => {
  const screens = useBreakpoint();
  const isMobile = !screens.sm;

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Modal
      open={isOpen}
      onCancel={handleClose}
      width={isMobile ? '100vw' : 650}
      title='👍 Confirmação de endereço recebida!'
      closable
      footer={
        <div className='m-2 flex justify-end gap-2.5'>
          <Button onClick={handleClose} type='primary' size='large'>
            Fechar
          </Button>
        </div>
      }
    >
      <p className='text-text mb-5! text-base font-bold'>Olá {name},</p>
      <div className='flex flex-col gap-3'>
        <p className='m-0!'>
          Agradecemos por confirmar que seu endereço permanece o mesmo. Sua atenção aos detalhes nos ajuda a garantir
          que seus brindes e reconhecimentos cheguem corretamente.
        </p>
        <p className='m-0!'>
          👉 <strong>Em breve, você receberá seus prêmios diretamente no endereço confirmado.</strong> 👈
        </p>
        <p className='m-0!'>Continue alcançando grandes sucessos no Programa Elite!</p>
      </div>
    </Modal>
  );
};

export default ConfirmAddress;
